// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTextTradeShowTeaser_container__FeIep","title":"PageTextTradeShowTeaser_title__1vsec","text":"PageTextTradeShowTeaser_text__2hRuQ"};